import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import conditional from './conditional.js'
import control from './control/control.js'
import helpers from './helpers/helpers.js'
import main from './main.js'

export default contract({
  conditional: array([
    conditional
  ]),
  control: array([
    control
  ]),
  helpers,
  main: array([
    main
  ])
})
